import TabPage from "./tab-page";
import BaseViewModel2 from "./base-view-model2";
import GenericListSearchTab from "./generic-list-search-tab";
import * as ko from "knockout";
import ConfigurationItemAuditDialog from "./configuration-item-audit-dialog";
abstract class GenericListTabHistory extends GenericListSearchTab {
    PermissionAuditTrail: string;
    constructor(tabPage: TabPage, parent: BaseViewModel2) {
        super(tabPage, parent);
        this.BindingToolbar = {
            buttons: this.ToolbarButtons,
            click: this.ToolbarClickHistory,
            toolbarName: this.ToolbarName,
            formName: null,
            applicationId: null
        };
    }
    ToolbarClickHistory = (button: Interfaces.Bao.BaoMenuItem) => {
        this.ToolbarClick(button);
        var key = ko.unwrap(button.ActionKey);
        switch (key) {
            case this.PermissionAuditTrail:
                this.AuditTrail();
                break;
        }
    };
    UrlAuditTrailOverview(): string {
        return this.ControllerUrl + "/CreateAuditTrailOverview";
    }
    AuditTrail(): any {
        let auditDialog = new ConfigurationItemAuditDialog(this.GetParentId(), ko.unwrap(this.TabPage.Title), this.TabPage, this.UrlAuditTrailOverview(), true);
        auditDialog.Open();
    }
    init() {
        return super.init().then((result: any) => {
            this.PermissionAuditTrail = result.Definition.FormName + "AuditTrail";
        });
    }
}
export default GenericListTabHistory;